import React from 'react';
import { Typography } from '../../components/Typography';
import { ComponentTypes } from '../../types';
import { AppStoreIcon } from '../../assets/icons';

import phoneImageLight from '../../assets/images/phone-full-size-light.webp';
import phoneImageDark from '../../assets/images/phone-full-size-dark.webp';

import styles from './index.module.scss';
import { AppButton } from '../../components/AppButton';
import { useAppContext } from '../../app/providers/useProvider';
import { openAppLink } from '../../lib/functions';

export const HeroSection = () => {
  const {
    isDark,
    queryState: { isMobile, isOnlyTablet },
  } = useAppContext();

  return (
    <section className={styles.container}>
      <div data-aos="fade-right" data-aos-once="false" className={styles.boxOuter}>
        <div className={styles.textSection}>
          <Typography className={styles.title} componentType={ComponentTypes.Title} level="h1">
            Your Supplements App.
            <br /> Personalized to You.
          </Typography>

          <AppButton className={styles.iconButton} onClick={openAppLink}>
            <AppStoreIcon />
          </AppButton>
        </div>
      </div>

      <div
        data-aos={isMobile || isOnlyTablet ? 'fade-right' : 'fade-left'}
        data-aos-once="false"
        className={styles.imageSection}
      >
        <img
          src={isDark ? phoneImageDark : phoneImageLight}
          alt="app-presentation"
          className={styles.image}
        />
      </div>
    </section>
  );
};
